export default __webpack_public_path__ + "static/media/tutorial3-2.a4c34624.png";